import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Typography, Button, withStyles } from '@material-ui/core'

import * as STOCK from '../../redux/actions/stocks'
import * as CONSTANTS from '../../utils/constants'

import SearchableHeader from '../common/SearchableHeader'
import SimpleList from '../common/SimpleList'
import RentExtendModal from './RentExtendModal'
import RentPVPPModal from './RentPVPPModal'

const styles = theme => ({
    listContainer: {
        padding: 24,
        overflow: 'auto'
    },
    subtitle: {
        fontSize: '36px',
        fontWeight: '500',
        paddingTop: '20px',
        color: theme.palette.primaryColor,
        display: 'block',
        width: '350px'
    },
    table: {
        marginTop: '20px'
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    withoutSidebar: {
        padding: '24px 36px 24px 0px'
    }
})

class Rent extends Component {


    state = {
        renderPage: false,
        rents: [],
        from: 0,
        openRentExtendModal: false,
        openRentPVPPModal: false,
        selectedRow: null,
        rowsPerPage: CONSTANTS.DEFAULT_ROWS_PER_PAGE_VALUE,
        search: '',
        headerFields: this.props.language.simpleTable.headerRent,
    }

    componentDidMount() {
        this.getRents()
    }

    getRents = () => {
        let params = {
            search: this.state.search
        }

        return this.props.get({
            ...params
        }).then(rentResponse => {
            this.setState({
                rents: rentResponse.rows,
                count: rentResponse.count,
                renderPage: true
            })
            return Promise.resolve()
        })
    }

    changeRowsPerPageHandler = rowsPerPage => {
        this.setState({ rowsPerPage }, () => this.getRents())
    }

    changePageHandler = currentFrom => {
        this.setState({ from: currentFrom }, () => this.getRents())
    }

    onSearch = search => this.setState({ search }, () => this.getRents())

    render() {
        const { classes } = this.props
        if (this.state.renderPage) {
            return (<>
                <div className={classes.titleContainer}>
                    <SearchableHeader
                        placeholder={this.props.placeholderLanguage}
                        title={this.props.language.titleRent}
                        onSearch={this.onSearch}
                    />
                </div>
                <div className={`${!this.props.sidebarReducer.displaySidebar ? this.props.classes.withoutSidebar : ""} ${this.props.classes.listContainer}`}>
                    <RentExtendModal
                        onClose={() => this.setState({ selectedRow: null, openRentExtendModal: false }, this.getRents)}
                        row={this.state.selectedRow}
                        open={this.state.openRentExtendModal} />
                    <RentPVPPModal
                        onClose={() => this.setState({ selectedRow: null, openRentPVPPModal: false }, this.getRents)}
                        row={this.state.selectedRow}
                        open={this.state.openRentPVPPModal} />
                    <SimpleList
                        setRentExtendModal={row => this.setState({ openRentExtendModal: true, selectedRow: row })}
                        setRentPVPPModal={row => this.setState({ openRentPVPPModal: true, selectedRow: row })}
                        headerFields={this.state.headerFields}
                        getRents={this.getRents}
                        actions={[]}
                        items={this.state.rents}
                        countTitle={this.props.language.carsInStock}
                        title={<Typography className={this.props.classes.subtitle} component='span'>{this.props.language.titleRent}</Typography>}
                        actionsTitle={this.props.language.simpleTable.actionsTitle}
                        disableBorders
                        selectedOption={CONSTANTS.RENT_OPTION}
                        onSelect={stock => this.onSelectHandler(stock)}
                        noHeader
                        search={{
                            onSearch: this.onSearch
                        }}
                        rowsPerPage={this.state.rowsPerPage}
                        count={this.state.count}
                        changeRowsPerPage={this.changeRowsPerPageHandler}
                        changePageHandler={this.changePageHandler}
                    />
                </div>
            </>)
        }
        else return null
    }
}

const mapStateToProps = state => ({
    language: state.languageReducer.i18n.stock,
    login: state.loginReducer,
    sidebarReducer: state.sidebarReducer,
    placeholderLanguage: state.languageReducer.i18n.car.searchPlaceholder
})

const mapDispatchToProps = dispatch => ({
    get: options => dispatch(STOCK.getRented(options))
})

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Rent))